
import * as Yup from 'yup';
import { Dto } from "../../../parts/crud/dto";
import { FormikValues } from 'formik';
import { error } from 'console';
import { processPost } from '../../../../services/api';



export class serverDto extends Dto {

  constructor() {

    super();
    this.data.initialValues = {
      serverDescription: '',
      serverHost: '',
      serverPort: '',
      serverCode: '',
      serverUsername: '',
      serverPassword: '',
      serverConfirmPassword: '',
      licenseToken: '',
      lat:'',
      lng:'',
      autoAddToExctractor: true,
    }
    this.data.validationSchema = Yup.object({
      serverDescription: Yup.string().required("GENERIC.ERRORS.REQUIRED"),
      serverHost: Yup.string().required("GENERIC.ERRORS.REQUIRED"),
      serverPort: Yup.string().required("GENERIC.ERRORS.REQUIRED"),
      serverCode: Yup.string().required("GENERIC.ERRORS.REQUIRED"),
      serverUsername: Yup.string().required("GENERIC.ERRORS.REQUIRED"),
    
      

      licenseToken: Yup.string().nullable(),
      
      
    });

  }

  updateData(data: any): void {
    super.updateData(data);
    /*
    console.log("autoAddToExctractor", data.data.autoAddToExctractor);
    if(data.data.autoAddToExctractor == 1){
      this.data.initialValues.autoAddToExctractor = true;
    }else{
      this.data.initialValues.autoAddToExctractor = false;
    }
      */
  }
  async otherValidation(values: FormikValues, id: number | null) {
    let errors: any = {};
    if(id == null){
      if(values.serverPassword === ""){
        errors.serverPassword = "GENERIC.ERRORS.REQUIRED";
      }
      if(values.serverConfirmPassword === ""){
        errors.serverConfirmPassword = "GENERIC.ERRORS.REQUIRED";
      }
      if(values.serverPassword!=="" && values.serverConfirmPassword!=="" && values.serverPassword !== values.serverConfirmPassword){
        errors.serverConfirmPassword = "GENERIC.ERRORS.PASSWORDS_DO_NOT_MATCH";
        errors.serverPassword = "GENERIC.ERRORS.PASSWORDS_DO_NOT_MATCH";
      }

    }else{
      if(values.serverPassword!=="" && values.serverConfirmPassword!=="" && values.serverPassword !== values.serverConfirmPassword){
        errors.serverConfirmPassword = "GENERIC.ERRORS.PASSWORDS_DO_NOT_MATCH";
        errors.serverPassword = "GENERIC.ERRORS.PASSWORDS_DO_NOT_MATCH";
      }
    }

    return errors;
  }
}